// third-party
import { configureStore, combineReducers } from '@reduxjs/toolkit';
import { useDispatch as useAppDispatch, useSelector as useAppSelector } from 'react-redux';
import { persistStore, persistReducer, FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER } from 'redux-persist';

// project import
import storage from 'redux-persist/lib/storage';
import auth from 'slices/auth';
import menu from 'slices/menu';
import snackbar from 'slices/snackbar';
import config from 'slices/config';
import services, { authApi } from 'services';

// ==============================|| REDUX TOOLKIT - MAIN STORE ||============================== //

const persistConfig = {
  key: 'root',
  version: 1,
  storage,
  whitelist: ['auth', 'menu']
};

const rootReducer = combineReducers({
  auth,
  menu,
  snackbar,
  config,
  [authApi.reducerPath]: authApi.reducer,
  ...services.reduce((acc, service) => ({ ...acc, [service.reducerPath]: service.reducer }), {})
});

const persistedReducer = persistReducer(persistConfig, rootReducer);

const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER]
      }
    }).concat(authApi.middleware, ...services.map((service) => service.middleware))
});

const persistor = persistStore(store);

const { dispatch } = store;

const useDispatch = () => useAppDispatch();
const useSelector = useAppSelector;

export { store, dispatch, persistor, useSelector, useDispatch };
